import { Component, inject } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { ToastAnimation } from '../../animations/container-animation';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    animations: [ToastAnimation.show],
    preserveWhitespaces: false,
    imports: [MatIcon]
})
export class ToastComponent extends Toast {
  protected toastrService: ToastrService;
  toastPackage: ToastPackage;

  undoString = 'undo';

  constructor() {
    const toastrService = inject(ToastrService);
    const toastPackage = inject(ToastPackage);

    super(toastrService, toastPackage);
    this.toastrService = toastrService;
    this.toastPackage = toastPackage;

    this.toastType = toastPackage.toastType;
  }

  toastType: string = 'toast-success';

  action(event: Event) {
    event.stopPropagation();
    this.undoString = 'undid';
    this.toastPackage.triggerAction();
    return false;
  }
}
